import type { EventTrackingProps } from '../trackEvent'
import { trackEvent } from '../trackEvent'

export const trackVaultButtonEvent = ({ event, params }: EventTrackingProps) => {
  trackEvent({ event, params })
}
